import type { PartialMessage } from '@bufbuild/protobuf'
import type { Media } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/media_pb'
import tinycolor from 'tinycolor2'

import { convertToOverlayNumber } from '@/components/page-theme/theme.utils'

export const bannerTextClasses = (bannerLuminance: number | null) => {
  if (bannerLuminance === null) {
    return 'text-page-text'
  }

  if (bannerLuminance > 0.65) {
    return 'text-black'
  } else if (bannerLuminance > 0.5) {
    return 'text-white [text-shadow:_0_1px_8px_rgb(0_0_0_/_30%),_0_1px_24px_rgb(0_0_0_/_22%)]'
  } else if (bannerLuminance > 0.33) {
    return 'text-white [text-shadow:_0_1px_8px_rgb(0_0_0_/_20%),_0_1px_24px_rgb(0_0_0_/_12%)]'
  } else if (bannerLuminance > 0.25) {
    return 'text-white [text-shadow:_0_1px_8px_rgb(0_0_0_/_10%),_0_1px_24px_rgb(0_0_0_/_6%)]'
  }

  return 'text-white'
}

const getOverlayNumber = (media?: PartialMessage<Media>) => {
  if (media?.overlayBackground) {
    return convertToOverlayNumber(media.overlayBackground)
  }
  return 0
}

export const getLuminance = (media?: PartialMessage<Media>) => {
  const overlayNumber = getOverlayNumber(media)

  if (overlayNumber !== 0) {
    return (overlayNumber + 100) / 200 // Simplified normalization
  }

  if (media?.color) {
    return tinycolor(media.color).getLuminance()
  }

  return null
}
